module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNjM2MxYmI7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY19wZW5fZ3JheTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMCAxMi43MSAwIDE2IDMuMjkgMTYgMTMuMTYgNi4xMyA5Ljc4IDIuNzYgMCAxMi43MSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE1LjczLDMuNTZhLjg2Ljg2LDAsMCwwLDAtMS4yMmwwLDAtMi0yYS44Ni44NiwwLDAsMC0xLjIyLDBsMCwwLTEuNiwxLjYsMy4yOSwzLjM3WiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_pen_gray.svg
// module id = Jbkw
// module chunks = 1